import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import { Income } from './types'

export const incomeByDayListMounted = createEvent()

export const getIncomeByDay = fx<void, Income[]>({
  method: 'GET',
  url: `/transaction_request/kpi_by_day_in_month`,
})

export const $incomeByDay = restore<Income[]>(
  getIncomeByDay.doneData.map((a) => a.body),
  [],
)

sample({
  // @ts-ignore
  clock: incomeByDayListMounted,
  fn: () => {
    let month = new URLSearchParams(window.location.search).get('month')
    return {
      url: `/transaction_request/kpi_by_day_in_month?month=${month}`,
    }
  },
  target: getIncomeByDay,
})
